import Vue from 'vue';
import { Component, Watch, Prop } from 'vue-property-decorator';
import { handleClose, openReserveCalendarItem, openReserveResourceDate } from '@reserve/popup-handler';
import { getAmpm, getFullTimetext, getTimetext } from '@reserve/disp-helper';
import modalHelper from '@appbase/util/modal-helper';
import OccurrenceSelect from '@reserve/components/OccurrenceSelect.vue';
import EventDetailHover from '@reserve/components/EventDetailHover.vue';

@Component({
    components: {
        EventDetailHover
    },
})
export default class WeekDayItem extends Vue {
    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //
    @Prop({type:Object}) item!: reserve.DateItem

    eventsModel: reserve.CalendarItem[] = [];

    @Watch('item')
    itemChanged(newVal: reserve.DateItem) {        
        this.eventsModel = newVal.events.filter(e => e.id !== 'null');        
    }

    get isHeightAdjust() {
        if(this.item.events.length > 1) {
            return this.item.events[0].id === 'null';
        } else {
            return false;
        }
    }

    getTimetext(eventTime: string) {
        return getTimetext(eventTime);
    }

    getAmpm(eventTime: string) {
        return getAmpm(eventTime);
    }

    getFullTimetext(event: reserve.CalendarItem) {        
        return getFullTimetext(event);
    }

    getColorClass(event: reserve.CalendarItem) {
        var colorClass: any = {};
        colorClass[event.color] = true; 

        return colorClass;
    }

    onEventDblClick(event: reserve.CalendarItem) {
        if (event.appointmentType === 'Occurrence' || event.appointmentType === 'Exception') {
            modalHelper.show({ component: OccurrenceSelect, force: true, value: event });
        } else {
            openReserveCalendarItem(event);
        }
    }
}